module.exports = __webpack_public_path__ + "static/img/aa-8.472729c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aa-8.png
// module id = Fwt3
// module chunks = 1